import styled from 'styled-components';
import TimeDisplay from './TimeDisplay';
import { colorSchema } from 'utils/style';

export default styled(TimeDisplay)`
  .time-display {
    color: ${colorSchema('grey700')};
    font-weight: 500;
  }
`;
